<template>
  <section class="space-section" id="about-section">
    <div>
      <b-row>
        <!-- View tablet <= 1024px -->
        <b-col cols="12" sm="12" md="12" lg="12" order="1" order-sm="1" order-md="1" order-lg="1" class="tablet_view">
          <div>
            <h5 class="abt-title gotham-medium abt-title-spaces">{{ $t('about.title') }}</h5>
            <p class="abt-paragraph gotham-book abt-paragraph-spaces">
              {{ $t('about.paragraph1_content') }}<br><br>
              {{ $t('about.paragraph2_content') }}
            </p>
          </div>
        </b-col> 
        <!-- View web > 1024 -->
        <b-col cols="12" sm="12" md="12" lg="6" xl="6" order-lg="1" class="web_view">
          <div>
            <h5 class="abt-title gotham-medium abt-title-spaces">{{ $t('about.title') }}</h5>
            <p class="abt-paragraph gotham-book abt-paragraph-spaces">
              {{ $t('about.paragraph1_content') }}<br><br><br>
              {{ $t('about.paragraph2_content') }}<br><br><br>
              {{ $t('about.paragraph3_content') }}<br><br>
            </p>
          </div>
        </b-col>
        <!-- View tablet <= 1024px -->
        <b-col cols="12" sm="12" md="6" lg="6" order="3" order-sm="3" order-md="2" order-lg="2" class="tablet_view">
          <div>
            <p class="abt-paragraph gotham-book abt-paragraph-spaces-tablet">
              {{ $t('about.paragraph3_content') }}<br><br>
              <!-- {{ $t('about.paragraph2_content') }}<br><br> -->
              <!-- {{ $t('about.paragraph2_content') }} -->
            </p>
          </div>
        </b-col> 
        <!-- View web and view tablet <= 1024 && > 1024-->
        <b-col cols="12" sm="12" md="6" lg="6" xl="6" order="2" order-sm="2" order-md="3" order-lg="2">
          <div class="abt-overlapping text-center">
            <ul class="abt-grid-container">
              <!-- <li><img :src="require('../assets/img/about.jpg')" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center" /></li> -->
              <!-- <li><img :src="require('../assets/img/adult.jpg')" data-aos="fade-left" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center" /></li> -->
                <li><img v-lazy="imgUrl1" alt="Mar" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center" /></li>
                <li><img v-lazy="imgUrl2" alt="Personas" data-aos="fade-left" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center" /></li>

              <li data-aos="custom-zoom" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center"></li>
            </ul>
          </div>
        </b-col>
        <!-- View tablet <= 1024px -->
        <b-col cols="12" sm="12" md="12" lg="12" order="4" order-sm="4" order-md="4" order-lg="4" class="abt-space-manifest tablet_view">
          <div class="abt-cards-container">
            <div data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-bottom" data-aos-offset="200">
              <h2>{{ $t('about.manifest_title') }}</h2>
              <p>
                <br>
                {{ $t('about.paragraph1_manifest') }}<br><br><br>
                {{ $t('about.paragraph2_manifest') }}
              </p>
            </div>
            <div data-aos="fade-up" data-aos-once="false" data-aos-duration="1000" data-aos-anchor-placement="top-center" data-aos-offset="300">
              <h2>{{ $t('about.marabunta_title') }}</h2>
              <p>
                {{ $t('about.paragraph1_marabunta') }}<br><br>
                {{ $t('about.paragraph2_marabunta') }}
              </p>
            </div>
          </div>
        </b-col>
        <!-- View web > 1024 -->
        <b-col cols="12" sm="12" md="12" lg="12" xl="12" order-md="3" class="abt-space-manifest web_view">
          <div class="abt-cards-container">
            <div data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center">
              <h2>{{ $t('about.manifest_title') }}</h2>
              <p>
                <br>
                {{ $t('about.paragraph1_manifest') }}<br><br><br>
                {{ $t('about.paragraph2_manifest') }}
              </p>
            </div>
            <div class="txt-marabunta" data-aos="fade-up" data-aos-once="false" data-aos-duration="1000" data-aos-anchor-placement="center-center">
              <h2>{{ $t('about.marabunta_title') }}</h2>
              <p>
                {{ $t('about.paragraph1_marabunta') }}<br><br>
                {{ $t('about.paragraph2_marabunta') }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col cols="11" sm="11" md="11" lg="10" xl="9" style="margin-top: 9.2%">
          <div :class="fullscreen" id="video-section" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-bottom" data-aos-offset="200">
            <div class="text-center embed-responsive embed-responsive-16by9">
              <video id="video-marabunta" playsinline class="embed-responsive-item" muted="muted" :src="require('../assets/video/'+ $t(video_ruta))" :poster="require('../assets/img/Loader.gif')"></video>
            </div>
            <div class="abt-button-video" id="id-button-video" @click="play" :style="{ visibility: visibilityPlay }">
              <b-icon :icon="iconVideo"></b-icon>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </section>
</template>


<style>
.space-section{
  margin-top: 5rem;
}

.tablet_view{
  display: none;
}

.gotham-bold{
  font-family: "Gotham Bold Regular";
}

.gotham-book{
  font-family: "Gotham Book Regular";
}

.gotham-light{
  font-family: "Gotham light Regular";
}
.gotham-medium{
  font-family: "Gotham Medium Regular";
}

#video-marabunta{
  background-color: #1D2B3C;
}

.abt-title{
  font-size: 32px;
  color: #1D2B3C;
  letter-spacing: 2.46px;
  line-height: 36px;
}

.abt-title-spaces{
  margin: 0 0 0 8%;
}

.abt-paragraph{
  color: #1D1D1D;
  font-size: 20px;
  letter-spacing: 1.54px;
  line-height: 28px;
}

.abt-paragraph-spaces{
  margin: 7% 0 0 16.5%;
}

.abt-overlapping {
  margin: 0 8% 1%;
}

.abt-overlapping ul{
  list-style: none;
  margin: 0 auto;
  padding: 0;
}

.abt-overlapping li:nth-child(1) {
  grid-column: 1/span 4;
  grid-row: 2/span 3;
  z-index: -2;
}

.abt-overlapping li:nth-child(2) {
  grid-column: 3/span 4;
  grid-row: 1/span 3;
  z-index: -1;
}

.abt-overlapping li:nth-child(3) {
  background-color: #22C3D1;
  grid-column: 3/span 2;
  grid-row: 2/span 1;
  opacity: 0;
  z-index: 0;
}

.abt-overlapping img {
  display: block;
  width: 100%;
}

.abt-grid-container {
  display: grid;
  grid-template-columns: 3fr 3fr 5fr 5fr 3fr 3fr;
  grid-template-rows: 2fr 6fr 2fr;
  max-width: 700px;
}

.abt-space-manifest{
  margin-top: -12%;
}

.abt-cards-container {
  grid-template-columns: 3fr 16fr 3fr 16fr;
  grid-template-rows: 3fr 4fr 4fr 3fr;
  display: grid;
  margin: 0;
  max-width: 100%;
  padding: 0;
}

.abt-cards-container div:nth-child(1){
  background-color: #04182E;
  color: #FFF;
  grid-row: 1/span 3;
  grid-column: 1/span 2;
}

.abt-cards-container div:nth-child(2){
  background-color: #2ABECC;
  color: #FFF;
  grid-row: 2/span 3;
  grid-column: 2/span 2;
}

.abt-cards-container div:nth-child(1) h2, .abt-cards-container div:nth-child(2) h2{
  font-family: "Gotham Medium Regular";
  font-size: 32px;
  margin: 8% 0 0 8%;
  letter-spacing: 2.46px;
  line-height: 36px;
}

.abt-cards-container div:nth-child(1) p, .abt-cards-container div:nth-child(2) p{
  font-family: "Gotham Book Regular";
  font-size: 20px;
  margin: 7% 11.5% 0 16.5%;
  padding-bottom: 10%;
  letter-spacing: 1.54px;
  line-height: 28px;
}

.abt-button-video:hover {
  background-position: 0 100%;
}

.abt-button-video:hover .b-icon{
  color: #FFF !important;
}

.abt-button-video{
  background-size: 100% 200%;
  background-image: linear-gradient(to top, #04182E 50%, transparent 50%);
  border: 2px solid #1D2B3C !important;
  bottom: -9%;
  cursor: pointer;
  padding: 16px; 
  position: absolute;
  right: 9%;
  transition: background-position 1s;
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
}

.abt-button-video .b-icon{
  color: #1D2B3C;
  font-size: 60px;
}

[data-aos="custom-zoom"] {
  opacity: 0.35;
  transition-property: opacity,transform;
}

[data-aos="custom-zoom"].aos-animate {
  opacity: 0.35 !important;
  transform: translateZ(0) scale(1);
}

/* video::-webkit-media-controls {
  display:block !important;
} */





/* //////////////////////////////////////////////////////////// */
.close{
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
  z-index: 999;
}

.trailer{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background: rgba(0, 0, 0, .95);
  width: 100%;
  height: 100.2%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 1800px) {
  .abt-title{
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
  }
  .abt-paragraph{
    font-size: 16px;
    letter-spacing: 1.23px;
    line-height: 25px;
  }
  .abt-cards-container div:nth-child(1) h2, .abt-cards-container div:nth-child(2) h2{
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
  }

  .abt-cards-container div:nth-child(1) p, .abt-cards-container div:nth-child(2) p{
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 1.23px;
  }
  .abt-button-video{
    padding: 6px;
  }
  .tm-content {
    margin: 0px 7% !important;
  }
}

@media (max-width: 1704px) {
  .abt-cards-container{
    grid-template-rows: 3fr 4fr 4fr 3fr;   
  }
}

@media (max-width: 1685px) {
  .abt-space-manifest{
    margin-top: -13%;
  }
}

@media (max-width: 1540px) {
  .card-team img{
    width: 250px !important;
    height: 250px !important;
  }
  .abt-space-manifest{
    margin-top: -8%;
  }
}

@media (max-width: 1430px) {
  .abt-cards-container{
    grid-template-rows: 3fr 6fr 6fr 3fr;   
  }
  .abt-button-video{
    bottom: -8%;
  }
  .abt-button-video .b-icon{
    color: #1D2B3C;
    font-size: 60px;
  }
}

@media (max-width: 1360px) {
  .abt-space-manifest{
    margin-top: 0%;
  }
  .abt-button-video{
    bottom: -9%;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (max-width: 1200px) { 
  .card-team img{
    width: 195px !important;
    height: 195px !important;
  }
  .abt-space-manifest{
    margin-top: 10%;
  }
}

@media (max-width: 1024px) { 
  .tablet_view{
    display: block;
  }
  .web_view{
    display: none;
  }
  .abt-title-spaces{
    margin: 0 0 0 4.6%;
  }
  .abt-paragraph-spaces{
    margin: 3% 8% 0 8%;
  } 
  .abt-paragraph-spaces-tablet{
    margin: 3% 0 0 16.5%;
  } 
  .abt-cards-container{
    margin: 0 9% 0 9%;
    grid-template-columns: 3fr 3fr 3fr 3fr;
    grid-template-rows: 6fr 8fr 8fr 6fr;
  }
  .abt-cards-container div:nth-child(1){
    grid-row: 1/span 3;
    grid-column: 1/span 4;
  } 
  .abt-cards-container div:nth-child(2){
    grid-row: 2/span 3;
    grid-column: 1/span 4;
  } 
  .abt-cards-container div:nth-child(1) h2, .abt-cards-container div:nth-child(2) h2{
    /* font-family: "Gotham Bold Regular"; */
    /* font-size: 20px; */
    margin: 8% 0 0 8.7%;
  }
  .abt-cards-container div:nth-child(1) p, .abt-cards-container div:nth-child(2) p{
    /* font-family: "Gotham Book Regular"; */
    /* font-size: 16px; */
    margin: 4% 8.7% 0 8.7%;
    padding-bottom: 10%;
  }
  .abt-button-video{
    bottom: -10%;
  }
  .abt-button-video .b-icon{
    font-size: 50px;
  }
}

@media (max-width: 960px) {
  .abt-title{
    font-size: 18px;
    letter-spacing: 1.39px;
    line-height: 26px;
  }
  .abt-paragraph{
    font-size: 15px;
    letter-spacing: 1.16px;
    line-height: 23px;
  }
  .abt-cards-container div:nth-child(1) h2, .abt-cards-container div:nth-child(2) h2{
    font-size: 18px;
    letter-spacing: 1.39px;
    line-height: 26px;
  }

  .abt-cards-container div:nth-child(1) p, .abt-cards-container div:nth-child(2) p{
    font-size: 15px;
    line-height: 23px;
    letter-spacing: 1.16px;
  }
}

@media (max-width: 920px){
 .abt-cards-container{
    grid-template-rows: 5fr 6fr 6fr 5fr;  
  }
}

@media (max-width: 886px){
 .abt-cards-container{
    grid-template-rows: 4fr 6fr 6fr 4fr;  
  }
}

@media (max-width: 767px){
  .abt-title-spaces{
    margin: 0 0 0 7%;
  }
  .abt-paragraph-spaces{
    margin: 8% 7% 0 7%;
  } 
  .abt-grid-container {
    max-width: 350px;
  }
  .abt-paragraph-spaces-tablet{
    margin: 3% 7% 0 7%;
  } 
  .abt-overlapping{
    margin-top: 10%;
    margin-bottom: 10%;
  }
  .abt-cards-container{
    margin: 0;
  }
  .abt-button-video{
    bottom: -10%;
  }
  .abt-button-video .b-icon{
    font-size: 45px;
  }
}

@media (max-width: 580px){
  .abt-cards-container{
    grid-template-rows: 3fr 8fr 8fr 3fr;  
  }
  .abt-button-video{
    bottom: -12%;
  }
  .abt-button-video .b-icon{
    font-size: 35px;
  }
}

</style>

<script>
export default {
  name: "About",
  data(){
    return {
      video_ruta: "about.video_ruta",
      iconVideo: "play",
      // sizeVideo: "100%",
      fullscreen: "",
      visibilityPlay: "visible",
      visibilityClose: "hidden",
      imgUrl1:require('../assets/img/about.jpg'),
      imgUrl2:require('../assets/img/adult.jpg'),
    }
  },
  methods: {
    testScroll(){
      alert("hola");
    },
    handleScroll: function(evt, el) {
      // console.log(window.scrollY);
    if (window.scrollY > 50) {
      el.setAttribute("style", "background-color:red;");
    }
    return window.scrollY > 100;
    },
    play() {
      let playVideoBtn = document.getElementById('video-marabunta');
      let scll = document.querySelector("body");  

      if (playVideoBtn.paused || playVideoBtn.muted === true) {
        playVideoBtn.play();
        playVideoBtn.muted = false;
        // playVideoBtn.requestFullscreen();
        // this.iconVideo = "pause";
        // this.sizeVideo = "100%";
        // this.fullscreen = "trailer"
        this.visibilityClose = "visible";
        this.visibilityPlay = "hidden";
        scll.setAttribute("style", "overflow-y: hidden");
        playVideoBtn.setAttribute("controls",true);
        this.openFullscreen(playVideoBtn);
      } else {
        playVideoBtn.pause();
        // this.iconVideo = "play";
      }
    },
    close() {
      let playVideoBtn = document.getElementById('video-marabunta');
      let scll = document.querySelector("body"); 

      playVideoBtn.muted = true;
      playVideoBtn.controls = false;
      // this.sizeVideo = "100%";
      this.fullscreen = ""
      this.visibilityPlay = "visible"
      this.visibilityClose = "hidden";
      scll.setAttribute("style", "overflow-y: visible");
      this.closeFullscreen(playVideoBtn);
    },
    openFullscreen(elem){
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen(elem){
      if (elem.exitFullscreen) {
        elem.exitFullscreen();
      } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen();
      } else if (elem.webkitExitFullscreen) {
        elem.webkitExitFullscreen();
      } else if (elem.msExitFullscreen) {
        elem.msExitFullscreen();
      }
    }
  },
  mounted: function () {
    var widthBrowser = window.outerWidth;
    var videoMra = document.getElementById('video-marabunta');
    if(widthBrowser <= 600){
      // document.getElementById('id-button-video').style.display = "none";
      // videoMra.setAttribute("controls",true);
      if(localStorage.getItem("lang") == "en"){
        videoMra.setAttribute("src", require("../assets/video/placeholder_movil_en.mp4"));
      }else{
        videoMra.setAttribute("src", require("../assets/video/placeholder_movil.mp4"));
      }
    }

    document.addEventListener('aos:in:super-duper', () => {
      this.controlsVideo = true;
    }); 

    ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange", "webkitendfullscreen"].forEach(
        eventType => videoMra.addEventListener(eventType, exitHandler, false)
    );
    // document.addEventListener('fullscreenchange', exitHandler);
    const vm = this;
    function exitHandler() {
      if (!document.fullscreenElement) {
          vm.close();
      }
    }  

    class ViewPort{
      static visible(el){
        let coords = el.getBoundingClientRect();
        let windowsHeight = document.documentElement.clientHeight;
  
        return (coords.top < windowsHeight && (coords.top * -1) < windowsHeight);
      }
    }

    class PlayOnViewPort{
      constructor(video_selector){
        this.video = document.getElementById(video_selector);
        this.evaluate = this.evaluate.bind(this);
        this.bindEvents();
      }
    
      bindEvents(){
        window.addEventListener('scroll',this.evaluate)
      }
  
      evaluate(){
        // console.log(this.video);
        if(ViewPort.visible(this.video)){
          this.video.play().catch((e)=>{ console.log(e)});
        }else{
          this.video.pause();
        }
      }
    }

    (function(){
      new PlayOnViewPort("video-marabunta");
    })();
  }
};
</script>
